import {ShapeComponent, shapeComponent} from "set-state-compare/src/shape-component"
import classNames from "classnames"
import Link from "@kaspernj/api-maker/build/link"
import memo from "set-state-compare/src/memo"
import {PaymentMethod} from "models"
import PropTypes from "prop-types"
import React from "react"
import Routes from "shared/routes"
export default memo(shapeComponent(class ComponentsPaymentMethodsLink extends ShapeComponent {
  static defaultProps = {
    adminLayout: false,
    userLayout: false
  }

  static propTypes = {
    adminLayout: PropTypes.bool.isRequired,
    className: PropTypes.string,
    paymentMethod: PropTypes.instanceOf(PaymentMethod).isRequired,
    userLayout: PropTypes.bool.isRequired
  }

  render() {
    const {adminLayout, children, className, paymentMethod, userLayout, ...restProps} = this.props
    const generatedClassName = classNames("components--class-steps--link", className)
    const to = this.to()

    if (to) {
      return (
        <Link className={generatedClassName} to={to} {...restProps}>
          {children || paymentMethod.name()}
        </Link>
      )
    }

    return (
      <span className={generatedClassName} {...restProps}>
        {children || paymentMethod.name()}
      </span>
    )
  }

  to() {
    const {adminLayout, paymentMethod} = this.p

    if (adminLayout) return Routes.superAdminPath({model: "PaymentMethod", model_id: paymentMethod.id()})
  }
}))
